import {
  App,
  AppCategory,
  AppStub,
  AppType,
  isRealAppData,
} from '@web-catalog/types';

import {ROUTES} from '@web-catalog/routes';

import {BreadcrumbsBackstackItem} from '@web-catalog/ui-kit/Breadcrumbs';

import {getCategoriesMap} from '@web-catalog/utils/getCategoriesMap/getCategoriesMap';

import {removeTrailingSlash} from '../url/path';

export const mainBackstackItem: BreadcrumbsBackstackItem = {
  path: ROUTES.root.index(),
  title: 'Каталог',
};

export const gamesBackstackItem: BreadcrumbsBackstackItem = {
  path: ROUTES.games.index(),
  title: 'Игры',
};

const prepareItems = (
  items: Array<BreadcrumbsBackstackItem>,
): Array<BreadcrumbsBackstackItem> =>
  items.map(({path, ...rest}) => ({
    path: path === '/' ? path : removeTrailingSlash(path),
    ...rest,
  }));

export const getBreadcrumbsBackstackForCategory = ({
  category,
  isGamesPage = false,
}: {
  category: AppCategory | null | undefined;
  isGamesPage?: boolean;
}) => {
  const result: Array<BreadcrumbsBackstackItem> = [];

  if (!category && !isGamesPage) {
    return result;
  }

  result.push(mainBackstackItem);

  if (isGamesPage && category) {
    result.push(gamesBackstackItem);
  }

  return prepareItems(result);
};

export const getBreadcrumbsBackstackForAppScreen = ({
  app,
  includeAppLink = false,
  categories,
}: {
  app: App | AppStub | null | undefined;
  includeAppLink?: boolean;
  categories: Array<AppCategory>;
}) => {
  const categoryMap = getCategoriesMap(categories);

  const result: Array<BreadcrumbsBackstackItem> = [];

  if (!app) {
    return result;
  }

  result.push(mainBackstackItem);

  if (app.appType === AppType.GAMES) {
    result.push(gamesBackstackItem);

    if (isRealAppData(app) && app.category) {
      result.push({
        path: ROUTES.games.page({category: app.category.toLowerCase()}),
        title: categoryMap[app.category]?.categoryName ?? app.category,
      });
    }
  } else {
    if (isRealAppData(app) && app.category) {
      result.push({
        path: ROUTES.root.page({category: app.category.toLowerCase()}),
        title: categoryMap[app.category]?.categoryName ?? app.category,
      });
    }
  }

  if (includeAppLink) {
    result.push({
      path: ROUTES.app.app(app.packageName),
      title: app.appName,
    });
  }

  return prepareItems(result);
};
